"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFormattedDateLocale = void 0;
const react_query_1 = require("@tanstack/react-query");
const dayjs_1 = __importDefault(require("dayjs"));
const advancedFormat_1 = __importDefault(require("dayjs/plugin/advancedFormat"));
const localeData_1 = __importDefault(require("dayjs/plugin/localeData"));
const localizedFormat_1 = __importDefault(require("dayjs/plugin/localizedFormat"));
const react_1 = require("react");
const userQuery_1 = require("../queries/userQuery");
const dateUtils_1 = require("./dateUtils");
dayjs_1.default.extend(localeData_1.default);
dayjs_1.default.extend(localizedFormat_1.default);
dayjs_1.default.extend(advancedFormat_1.default);
const useFormattedDateLocale = (date) => {
    const { data: currentUser } = (0, react_query_1.useQuery)(userQuery_1.userQuery);
    const [formattedDate, setFormattedDate] = (0, react_1.useState)('');
    const locale = (0, dateUtils_1.getDateFnsLocale)(currentUser?.language || 'en-US');
    (0, react_1.useEffect)(() => {
        dayjs_1.default.locale(locale);
        setFormattedDate((0, dayjs_1.default)(date).format('MMM Do YYYY, h:mm:ss a'));
    }, [currentUser?.language, date, locale]);
    return formattedDate;
};
exports.useFormattedDateLocale = useFormattedDateLocale;
